<h3 class="text-overflow">
    <i ng-if="isCheckedOut(item)" class="checkedOut" ng-class="statusIcon(item)" title="{{checkOutStatus(item)}}"></i>
    <a ng-click="onMainClick(item, $event)">
        <span ng-if="item.rowLock">[{{'changePending'|translate}}]</span>
        <span ng-bind-html="item.Title|cHighlight:highlight"></span>
    </a>
    <a class="details" ng-class="{isFavorite: item.IsFavorite}" ng-click="onFavoritesClick(item, $event)" ng-attr-title="{{ 'workflowList.favorite'|translate }}">
        <i class="fa fa-star-o" ng-if="!item.IsFavorite"></i>
        <i class="fa fa-star isFavorite" ng-if="item.IsFavorite"></i>
    </a><a class="details button" ng-click="onDetailsClick(item, $event)" ng-attr-title="{{ 'workflowList.details'|translate }}"><i class="fa fa-info"></i></a><!--a class="details button fat" ng-click="onMenuClick(item, $event)">&#x22EE;</a-->
</h3>
<p ng-if="item.Description" ng-bind-html="item.Description|cHighlight:highlight" class="description">
</p>
<c-property-list properties="item.itemProperties" highlight="highlight"></c-property-list>